export const seoConfig = {
  'index': {
    title: 'АртМандала - Расчет и создание Мандал Сети Света онлайн',
    description: 'Уникальный сервис для автоматизированного расчета и создания индивидуальных Мандал Сети Света. Обучение методике Урсулы Иррганг, бесплатные наборы и продвинутый онлайн калькулятор.'
  },
  'democalc': {
    title: 'Демо-расчет мандалы | АртМандала',
    description: 'Бесплатный демонстрационный расчет и построение шаблона Мандалы Сети Света онлайн. Испытайте базовый функционал калькулятора.'
  },
  'LearningSets': {
    title: 'Наборы для обучения и самопознания — АртМандала',
    description: 'Готовые наборы для расчёта Мандал Сети Света по темам: любовь, деньги, здоровье, отношения и другие. Обучающие материалы и практика по методике Урсулы Иррганг от 990 ₽.'
  },
  'PNDPolicy': {
    title: 'Политика конфиденциальности | АртМандала',
    description: 'Политика в отношении обработки персональных данных пользователей сервиса АртМандала.'
  },
  'OfertaView': {
    title: 'Публичная оферта | АртМандала',
    description: 'Договор публичной оферты об оказании услуг сервисом АртМандала.'
  },
  'ArticleView': {
    title: 'Статья о методике | АртМандала',
    description: 'Подробная статья о методике Мандал Сети Света, истории ее создания и принципах работы с сакральной геометрией.'
  },
  'blog': {
    title: 'АртМандала - Блог о Мандалах Сети Света',
    description: 'Статьи о методике Мандал Сети Света, истории ее создания и принципах работы с сакральной геометрией.'
  }
};

export const defaultMeta = {
  title: 'АртМандала - Терапия Мандалами Сети Света Онлайн',
  description: 'Создавайте и рассчитывайте Мандалы Сети Света онлайн. Бесплатные наборы, обучение методикам, расчет паттерна для вашего намерения.'
};
